import {
  useArcadeStoreLink,
  useArcadeStorePrompt,
} from '../hooks/useArcadeStorePrompt';
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogOverlay,
  DialogTitle,
  Text,
  VStack,
} from 'ui_2';
import img from '../assets/a_lot_of_part.png';
import { useEffect } from 'react';

export const ArcadeStorePrompt = () => {
  const link = useArcadeStoreLink();
  const { hasViewedPrompt, onPromptViewed } = useArcadeStorePrompt();

  useEffect(() => {
    if (hasViewedPrompt === false) {
      onPromptViewed();
    }
  });

  return (
    <Dialog defaultOpen={hasViewedPrompt === false}>
      <DialogOverlay className='z-50 bg-gray-900/40' />
      <DialogContent
        className='z-50 w-4/5 max-w-[400px] rounded-[20px]'
        aria-describedby='did-you-know'
      >
        <DialogClose asChild />
        <VStack className='items-center'>
          <img src={img} className='w-4/5 max-w-[200px]' />
          <VStack className='gap-2 text-center'>
            <DialogTitle>
              <Text font={'bold-md'} id='did-you-know'>
                Did you know you can redeem your PART for rewards?
              </Text>
            </DialogTitle>
            <Button onClick={() => window.open(link, '_target')}>
              Go to Puzzle Arcade Store
            </Button>
          </VStack>
        </VStack>
      </DialogContent>
    </Dialog>
  );
};
